import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import clsx from "clsx";
import Icon from "@mui/material/Icon";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import Drawer from "@mui/material/Drawer";
import Collapse from "@mui/material/Collapse";

import DrawerListItem from "../listItem/drawerListItem";
import "../../../styles/drawer.css";
import logo from "../../../images/phase-3/stirrup_logo/stirrup-logo.svg";
import { Link, useLocation } from "react-router-dom";
import DrawerUseStyles from "./drawerStyles";
import navItems from "./drawerItem";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "actions/auth/authAction";
import { Box, Tooltip, Typography } from "@mui/material";

function NavCustomDrawer({
  isOpen,
  setIsOpen,
  logOut,
  token,
  redirect,
  setRedirectValue,
  login,
}) {
  const queryClient = useQueryClient();

  let location = useLocation();
  const classes = DrawerUseStyles();

  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [tnc, setTnc] = useState(false);
  const user = useSelector((state) => state.user);

  // useEffect(() => {
  //   localStorage.setItem("isLoggedIn", user.isLoggedin);
  // }, [user]);

  const userType = user?.user_type; // localStorage.getItem("current_organisation_user_type");

  const handleDrawerToggle = () => {
    setOpen(!open);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const currentPath = location.pathname;
    setTnc(
      currentPath === "/privacy_policy" ||
        currentPath === "/tnc" ||
        currentPath === "/faq"
    );
  }, [location.pathname]);
  return (
    <div className={classes.root}>
      <CssBaseline />
      {!tnc && (
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
        >
          <List className={classes.head}>
            <ListItem className={classes.head}>
              <ListItemIcon>
                <IconButton
                  className={classes.iconButton}
                  onClick={handleDrawerToggle}
                >
                  <Icon>{open ? "close" : "menu"}</Icon>
                </IconButton>
              </ListItemIcon>
            </ListItem>
          </List>
          <List>
            <ListItem>
              <ListItemIcon>
                {open &&
                  !isOpen &&
                  login?.org_details &&
                  login?.org_details?.after_login &&
                  login?.org_details?.after_login?.logo && (
                    <div
                      style={
                        login?.org_details &&
                        login?.org_details?.after_login?.logo
                          ? login?.org_details?.after_login?.logo_styles
                          : JSON.parse(localStorage.getItem("logo_styles"))
                            ? JSON.parse(localStorage.getItem("logo_styles"))
                            : {}
                      }
                    >
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                        src={
                          login?.org_details &&
                          login?.org_details?.after_login?.logo
                            ? login?.org_details?.after_login?.logo
                            : localStorage.getItem("logo") &&
                              localStorage.getItem("logo")
                        }
                        alt="logo"
                      />
                    </div>
                  )}
                {open && !isOpen && (
                  <div>
                    <img
                      style={{
                        width: "70%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      src={logo}
                      alt="logo"
                    />
                  </div>
                )}
              </ListItemIcon>
            </ListItem>
          </List>
          {open && (
            <Box
              sx={{
                px: 2,
                mt: -4.9,
                mr: 2.2,
                textAlign: "right",
              }}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "10px" }}
              >
                App Version {process.env.REACT_APP_APP_VERSION_NOTE || "-"}
              </Typography>
            </Box>
          )}
          <List
            className={classes.list2}
            sx={{
              "&::-webkit-scrollbar": {
                width: "3px", // Make scrollbar width small (4px) for minimalistic look
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#c1daed8f", // Subtle thumb color for the scrollbar
                borderRadius: "8px", // Rounded look
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent", // Transparent background to show only the scrollbar line
              },
            }}
          >
            {navItems.map((item) => {
              if (item.screen && !user?.allowed_screens?.includes(item.screen))
                return null;

              // Check if current path starts with item.path (for nested routes)
              // Also need to handle exact match for root paths to avoid conflicts
              const isSelected =
                location.pathname === item.path ||
                location.pathname.startsWith(item.path + "/");

              return (
                <Link
                  key={item.index}
                  to={item.path}
                  className={
                    true
                      ? // login.isSubscriptionActive &&
                        // localStorage.getItem("status") !== "EXPIRED"
                        classes.link
                      : !item.disableStyle
                        ? classes.link
                        : classes.disabledLink
                  }
                >
                  <DrawerListItem
                    disabled={
                      !login.isSubscriptionActive &&
                      localStorage.getItem("status") === "EXPIRED" &&
                      item.disableStyle !== false
                    }
                    selected={isSelected}
                    className={classes.listitems}
                    onClick={() => {
                      if (item.isLogout) {
                        logOut(token);
                      } else if (redirect) {
                        setRedirectValue(false);
                      }
                    }}
                    button
                    data-tut={item.dataTut}
                  >
                    <ListItemIcon>
                      {open && <Icon fontSize="small">chevron_right</Icon>}
                      {item.icon && (
                        <Tooltip
                          title={item.label}
                          placement="right-end"
                          arrow
                          disableHoverListener={open} // disables when drawer is open
                        >
                          <Icon
                            component={"img"}
                            fontSize="small"
                            src={item.icon}
                          ></Icon>
                        </Tooltip>
                      )}
                    </ListItemIcon>
                    <Collapse timeout={0} in={open}>
                      <ListItemText secondary={item.label} />
                    </Collapse>
                  </DrawerListItem>
                </Link>
              );
            })}
          </List>
          <Divider style={{ marginTop: "auto" }} />
          <List className={classes.list}>
            <Link to="/login">
              <DrawerListItem
                selected={location.pathname === "/login"}
                className={classes.listitems}
                onClick={() => {
                  // logOut(token);
                  dispatch(userLogout());
                  dispatch({ type: "RESET_STATE" });
                  queryClient.clear();
                  localStorage.setItem("isLoggedIn", false);
                }}
                button
                name="logoutBtn"
              >
                <ListItemIcon>
                  <>
                    {open && <Icon fontSize="small">chevron_right</Icon>}
                    <Icon fontSize="small">logout</Icon>
                  </>
                </ListItemIcon>
                <Collapse timeout={0} in={open}>
                  {" "}
                  <ListItemText secondary="Logout" />
                </Collapse>
              </DrawerListItem>
            </Link>
          </List>
        </Drawer>
      )}
    </div>
  );
}

export default React.memo(NavCustomDrawer);
